import React from 'react';

import {bluetoothStartPairing} from '../../assets/images';
import {Button} from '../../components/Button';
import {Text} from '../../components/Typography';
import {Constants} from '../../constants';
import {Messages, Strings, interpolate} from '../../constants/Strings';
import {Screens} from '../../constants/navigation';
import {useBackPress} from '../../lib/hooks/useBackPress';
import type {MainNavigatorScreenProps} from '../../navigators/RootStackNavigator';
import {centerText} from '../../styles';
import {
  BodyContainer,
  ContentContainer,
  FlexImage,
  Footer,
  ImageContainer,
  Layout,
  TitleContainer,
} from '../components/composable';

interface Props
  extends MainNavigatorScreenProps<typeof Screens.BluetoothStartPairing> {}

export const BluetoothStartPairingScreen = ({navigation, route}: Props) => {
  const redirect = route.params?.redirect;

  useBackPress(() => {
    navigation.goBack();
    return true;
  });

  return (
    <Layout>
      <ImageContainer>
        <FlexImage source={bluetoothStartPairing} />
      </ImageContainer>

      <ContentContainer>
        <BodyContainer>
          <TitleContainer>
            <Text style={centerText} variant="h2">
              {Messages.START_PAIRING_TITLE}
            </Text>
          </TitleContainer>

          <Text style={[centerText]}>
            {interpolate(Messages.START_PAIRING_MSG, {
              appName: Constants.IS_WEB
                ? Strings.PATH_BROWSER
                : Strings.PUFFCO_CONNECT,
            })}
          </Text>
        </BodyContainer>

        <Footer>
          <Button
            onPress={() =>
              navigation.navigate(Screens.PairInstructions, {redirect})
            }>
            {Strings.START_PAIRING}
          </Button>
        </Footer>
      </ContentContainer>
    </Layout>
  );
};
